module.exports = __webpack_public_path__ + "media/images/projects/1-logo-bcff7025157e9926c4eaa0a002b76b61.png";